import { Skeleton } from '../../../components/Skeleton';
import { Heading2 } from '../../../components/shared/Heading';
import ArrowRight from '../../../assets/arrow-right-tail.svg?react';
import { useEffect, useMemo, useState } from 'react';
import {
  BookingChangeGroup,
  getReservationHistory,
} from '../../../apiMethods/getReservationHistory';
import { useNavigate, useParams } from 'react-router-dom';
import { BackButton } from '../../../components/shared/BackButton/BackButton';
import { format, isValid } from 'date-fns';
import { ru } from 'date-fns/locale/ru';

export const BookingHistory = () => {
  const { bookingId } = useParams<{ bookingId: string }>();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [changeGroups, setChangeGroups] = useState<BookingChangeGroup[]>([]);

  const fetchBookingHistory = async (bookingId: number) => {
    setLoading(true);
    const changeGroups = await getReservationHistory(bookingId);
    if (!changeGroups) {
      return;
    }

    setChangeGroups(changeGroups);
    setLoading(false);
  };

  useEffect(() => {
    if (!bookingId) {
      return;
    }
    fetchBookingHistory(Number(bookingId));
  }, [bookingId]);

  const historyGroups = useMemo(() => loading ? skeletonGroups : changeGroups, [loading, changeGroups])

  return (
    <main className="container mx-auto w-auto max-w-[768px] lg:w-[768px]">
      <div className="p-5">
        <BackButton onClick={() => navigate(-1)}>К бронированию</BackButton>
        <Heading2 className="mt-8 3xl:mt-0">История заказа</Heading2>
      </div>

      <div className="mx-5 divide-y divide-neutral-30">
        {historyGroups.map(changeGroup => (
          <ChangeGroup key={changeGroup.history_id} changeGroup={changeGroup} loading={loading} />
        ))}
      </div>
    </main>
  );
};

const formatHistoryDate = (date: string) => {
  const d = new Date(date);
  if (!isValid(d)) {
    return 'invalid-date';
  }

  return format(d, 'hh:mm:ss dd MMM yyyy', { locale: ru });
};

const ChangeGroup = ({
  changeGroup,
  loading,
}: {
  changeGroup: BookingChangeGroup;
  loading: boolean;
}) => {
  return (
    <div className="mt-4 pt-4 first-of-type:mt-0 first-of-type:pt-0">
      <div className="mb-2 flex justify-between text-right text-xs text-neutral-50 xl:text-sm">
        <Skeleton loading={loading} className="h-[20px] w-[100px]">
          <span>{changeGroup.user}</span>
        </Skeleton>
        <Skeleton loading={loading} className="h-[20px] w-[137px]">
          <span>{formatHistoryDate(changeGroup.history_date)}</span>
        </Skeleton>
      </div>
      <div className="space-y-2">
        {changeGroup.changes.map(change => (
          <ChangeEntry
            key={change.field_name}
            label={change.field_name}
            from={change.old_value}
            to={change.new_value}
            loading={loading}
          />
        ))}
      </div>
    </div>
  );
};

const ChangeEntry = ({
  label,
  from,
  to,
  loading
}: {
  label: string;
  from: string | number;
  to: string | number;
  loading?: boolean;
}) => {
  return (
    <div>
      <div className=" text-xs font-medium text-neutral-700 xl:text-sm">
        <Skeleton loading={loading} className="h-[16px] my-1 w-[100px]">
          {label}:
        </Skeleton>

      </div>

      <div className="flex items-center font-light">
        <div className="text-neutral-70">
          <Skeleton loading={loading} className="h-[20px] my-0.5 w-[80px]">
            {from}
          </Skeleton>
        </div>
        <div className="px-2 text-neutral-40">
          <ArrowRight />
        </div>
        <div className="font-light text-neutral-700">
          <Skeleton loading={loading} className="h-[20px] my-0.5 w-[80px]">
            {to}
          </Skeleton>
        </div>
      </div>
    </div>
  );
};

const buildEmptyChange = () => ({
  field_name: '',
  old_value: '',
  new_value: '',
})

const skeletonGroups: BookingChangeGroup[] = [{
  user: '',
  history_id: 1,
  history_date: '',
  changes: [buildEmptyChange(), buildEmptyChange(), buildEmptyChange()]
},
{
  user: '',
  history_id: 2,
  history_date: '',
  changes: [buildEmptyChange()]
},
{
  user: '',
  history_id: 3,
  history_date: '',
  changes: [buildEmptyChange(), buildEmptyChange()]
}
]

// const ChangeEntrySkeleton = () => {
//   return (
//     <div>
//       <Skeleton loading className={`h-[18px] w-[80px] `}></Skeleton>
//       <div className="flex items-center font-light">
//         <Skeleton loading className={`h-[24px] w-[80px] `}></Skeleton>
//         <span className="px-2 text-neutral-40">
//           <ArrowRight />
//         </span>
//         <Skeleton loading className={`h-[24px] w-[120px] `}></Skeleton>
//       </div>
//     </div>
//   );
// };
